import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const periods = ['Last 7 Days', 'Last 30 Days', 'Last 90 Days', 'YTD', 'Custom'];
const memberTypes = ['All Types', 'Premium Annual', 'Standard Monthly', 'Basic Monthly', 'Standard Quarterly'];
const segments = ['All Segments', 'New Members', 'At Risk', 'Champions', 'Inactive'];

const savedPresets = [
  { id: 1, name: 'At-Risk Monthly', icon: 'AlertTriangle' },
  { id: 2, name: 'Premium Renewals', icon: 'Star' },
  { id: 3, name: 'New This Month', icon: 'UserPlus' },
];

const FilterBar = ({ onFilterChange }) => {
  const [period, setPeriod] = useState('Last 30 Days');
  const [memberType, setMemberType] = useState('All Types');
  const [segment, setSegment] = useState('All Segments');
  const [activePreset, setActivePreset] = useState(null);
  const [showPresets, setShowPresets] = useState(false);

  const handlePreset = (preset) => {
    setActivePreset(preset?.id);
    setShowPresets(false);
    onFilterChange?.({ preset: preset?.name });
  };

  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-3 lg:p-4 mb-6 shadow-sm">
      <div className="flex flex-col lg:flex-row lg:items-center gap-3">
        <div className="flex items-center gap-2 flex-1 flex-wrap">
          {/* Period Selector */}
          <div className="flex items-center gap-1 bg-[var(--color-muted)] rounded-lg p-0.5 overflow-x-auto">
            {periods?.map((p) => (
              <button
                key={p}
                onClick={() => setPeriod(p)}
                className={`px-2.5 py-1.5 rounded-md text-xs font-caption font-medium whitespace-nowrap transition-all ${
                  period === p
                    ? 'bg-[var(--color-card)] text-[var(--color-primary)] shadow-sm'
                    : 'text-[var(--color-muted-foreground)] hover:text-[var(--color-foreground)]'
                }`}
              >
                {p}
              </button>
            ))}
          </div>

          {/* Member Type */}
          <select
            value={memberType}
            onChange={(e) => setMemberType(e?.target?.value)}
            className="text-xs font-caption text-[var(--color-foreground)] bg-[var(--color-muted)] border border-[var(--color-border)] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] cursor-pointer"
          >
            {memberTypes?.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>

          {/* Segment */}
          <select
            value={segment}
            onChange={(e) => setSegment(e?.target?.value)}
            className="text-xs font-caption text-[var(--color-foreground)] bg-[var(--color-muted)] border border-[var(--color-border)] rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[var(--color-primary)] cursor-pointer"
          >
            {segments?.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-2 flex-wrap">
          {/* Saved Presets */}
          <div className="relative">
            <Button
              variant="outline"
              size="sm"
              iconName="Bookmark"
              iconPosition="left"
              iconSize={13}
              onClick={() => setShowPresets(!showPresets)}
            >
              Presets
            </Button>
            {showPresets && (
              <div className="absolute top-full right-0 mt-2 w-48 bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl shadow-lg z-50 overflow-hidden">
                {savedPresets?.map((preset) => (
                  <button
                    key={preset?.id}
                    onClick={() => handlePreset(preset)}
                    className={`w-full flex items-center gap-2.5 px-3 py-2.5 text-sm font-caption text-left hover:bg-[var(--color-muted)] transition-colors ${
                      activePreset === preset?.id ? 'text-[var(--color-primary)] bg-teal-50' : 'text-[var(--color-foreground)]'
                    }`}
                  >
                    <Icon name={preset?.icon} size={14} color={activePreset === preset?.id ? 'var(--color-primary)' : 'var(--color-muted-foreground)'} />
                    {preset?.name}
                  </button>
                ))}
                <div className="border-t border-[var(--color-border)] p-2">
                  <button className="w-full flex items-center gap-2 px-2 py-1.5 text-xs font-caption text-[var(--color-primary)] hover:bg-teal-50 rounded-md transition-colors">
                    <Icon name="Plus" size={12} color="var(--color-primary)" />
                    Save Current Filter
                  </button>
                </div>
              </div>
            )}
          </div>

          <Button variant="ghost" size="sm" iconName="RotateCcw" iconPosition="left" iconSize={13}>
            Reset
          </Button>

          <Button variant="default" size="sm" iconName="Filter" iconPosition="left" iconSize={13}>
            Apply Filters
          </Button>
        </div>
      </div>
      {activePreset && (
        <div className="mt-3 flex items-center gap-2">
          <span className="text-xs text-[var(--color-muted-foreground)] font-caption">Active preset:</span>
          <span className="flex items-center gap-1.5 text-xs bg-teal-50 text-[var(--color-primary)] px-2.5 py-1 rounded-full font-caption font-medium">
            {savedPresets?.find((p) => p?.id === activePreset)?.name}
            <button onClick={() => setActivePreset(null)}>
              <Icon name="X" size={11} color="var(--color-primary)" />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};

export default FilterBar;